import React from 'react';

interface CarveOutRow {
  applyMultiProcedureDisc?: boolean;
}

/**
 * Multi-procedure discount display
 */
export const MultiProcDiscountTemplate: React.FC<{ value: boolean }> = ({ value }) => (
  <span>{value ? 'Yes' : 'No'}</span>
);

// Template function for grid column
export const multiProcDiscountTemplate = (props: CarveOutRow) => (
  <MultiProcDiscountTemplate value={props.applyMultiProcedureDisc || false} />
);

export default MultiProcDiscountTemplate;
